module.exports = __webpack_public_path__ + "media/promo/promo/images/card-3-f66099598a8160a6c9af5376dce6b1a3.jpg";